module.exports = __webpack_public_path__ + "img/slide12.cb47b390.png";